
import { useState, useEffect } from "react";
import Config from "../../Config";


import Calendar from "../../calendar/Calendar";
import InputTextArea from "../../helpers/InputTextArea";
import InputTime from "../../helpers/InputTime";

import InputUploader from "../../helpers/InputUploader";


import PlTitle from "../../elements/PlTitle";
import ChatWidget from "../msg/ChatWidget";


function Eat(props)
{


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);



    var dt = new Date();

    var strM = (dt.getMonth()+1)+"";
    if(strM.length == 1) strM = "0" + strM;

    var strD = dt.getDate()+"";
    if(strD.length == 1) strD = "0" + strD;

    var dateX  = dt.getFullYear()+"-"+strM+"-"+strD;

    //const [daySelected, setDaySelected] = useState(dateX);    

    var arrDef = new Array();
    arrDef.push({
        date: dateX,
        title: "wybrano " + dateX,
        className: "selected",
    });
    const [daysSelected, setDaysSelected] = useState(arrDef);

    const [view, setView] = useState('list');


    const [row, setRow] = useState({
        godzina1: '',
        tresc1: '',
        godzina2: '',
        tresc2: '',
        godzina3: '',
        tresc3: '',
        crypt: 'wall_' + Math.floor(Math.random() * 100000000) + "_"+Date.now()+"_"+props.userData.p_przedszkole_id+"_"+Math.floor(Math.random() * 100000000) ,        
    });
    const [b64, setB64] = useState({
        crypt :'',
        id: '',
        b64 : '',
        type : '',
        name : '',
    });
    const [errTab, setErrTab] = useState([]);  //z info od serwera..


    const clickOnDay = (date,title) => {
        

        var isSelected = false;
        for(var k=0; k<daysSelected.length ; k++)
        {
            if(daysSelected[k].date == date) {
                isSelected = true;
                break;
            }
        }

        if(isSelected == false)
        {
                var tmp = JSON.parse( JSON.stringify(daysSelected) );

                tmp.push({
                    date: date,
                    title: "wybrano " + date,
                    className: "selected",
                });
                setDaysSelected(tmp);
        }else 
        {
            var tmp = new Array()

            for(var k=0; k<daysSelected.length ; k++)
                {
                    if(daysSelected[k].date != date) {                                                
                        tmp.push(daysSelected[k]);
                    }
                }

            setDaysSelected(tmp);
        }



        setRow( {...row, ['godzina1']:'', ['tresc1']:'',  ['godzina2']: '', ['tresc2']:'' ,  ['godzina3']: '', ['tresc3']:'' }  );
        setB64( {...b64, ['crypt']:'', ['name']:'', ['b64']:'',["type"]:''    } );

        getData(date);
        //console.log("DT selected", date);
        
    }


    const changeView = (e) => {
        
            setView( e.target.getAttribute('v') );
         
    }


    const valChangeListener = (filedName, val, correct, msg) => {

        
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

    
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }  

    const goNextNew = () => {
        //console.log("goNext");
     //   saveData();
    }



    const completeUpload = (fileName, crypt) => {

        //console.log("completeUpload " + fileName + " - " + crypt);
        saveData();
 
    }




    const getData = (ds) => {
       
 
        props.mainView.setProgress(-2);

        var defDaysSel = "";
        if(daysSelected.length > 0)        
        {
            defDaysSel = daysSelected[0].date;
        }

        var req = {
            dzien: defDaysSel
        };


        if(ds != null && ds != undefined)
        {
             req = {
                dzien: ds
            };
        }


        fetch( Config.url + '/rest_v1_news,eat', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res);   
              
                                              
                        var files  = res.result.file;
 
                        if(res.result.txt != undefined)
                        {
                            var txts = res.result.txt;
                            if(txts.length > 0 ) setRow( {...row, ['godzina1']: txts[0].godzina, ['tresc1']:txts[0].tresc  }  );
                            if(txts.length > 1 ) setRow( {...row, ['godzina1']: txts[0].godzina, ['tresc1']:txts[0].tresc,  ['godzina2']: txts[1].godzina, ['tresc2']:txts[1].tresc  }  );
                            if(txts.length > 2 ) setRow( {...row, ['godzina1']: txts[0].godzina, ['tresc1']:txts[0].tresc,  ['godzina2']: txts[1].godzina, ['tresc2']:txts[1].tresc  ,  ['godzina3']: txts[2].godzina, ['tresc3']:txts[2].tresc }  );                        
                        }       

                        if(res.result.file != undefined)
                        {
                            if(res.result.file.length > 0) 
                            {
                                setB64( {...b64, ['crypt']:res.result.file[0].crypt, ['name']:res.result.file[0].nazwa, ['type']:res.result.file[0].typ_pliku, ['b64']:res.result.file[0].b64      } );

                                setView( "image" );
                            }
                        }
                        
                        
                        
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

    const saveData = () => {
       
 
        var daySelected = "";

        for(var k=0; k < daysSelected.length; k++)
        {
            daySelected +=   daysSelected[k].date + ",";
        }

        if( daysSelected.length < 1) return;


        props.mainView.setProgress(-2);

        var req = {
            dzien: daySelected,
            inne_dni: '',
            crypt: row.crypt,
            poz: [
                {
                    godzina: row.godzina1,
                    tresc: row.tresc1
                },
                {
                    godzina: row.godzina2,
                    tresc: row.tresc2
                },
                {
                    godzina: row.godzina3,
                    tresc: row.tresc3
                },
            ]

        };

        fetch( Config.url + '/rest_v1_news,eat_up', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(null);
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const delImages = () => {
       

        setRow( {...row, ['godzina1']:'', ['tresc1']:'',  ['godzina2']: '', ['tresc2']:'' ,  ['godzina3']: '', ['tresc3']:'' }  );
        setB64( {...b64, ['crypt']:'', ['nazwa']:'', ['b64']:''    } );
 
        props.mainView.setProgress(-2);


        if( daysSelected.length < 1) return;


        var daySelected = "";

        for(var k=0; k < daysSelected.length; k++)
        {
            daySelected +=   daysSelected[k].date + ",";
        }

        var req = {
            dzien: daySelected,
           
        };

        fetch( Config.url + '/rest_v1_news,eat_del_img', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(null);
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    if(tab == null)
    {
        setTab([]);
        getData(); 
        return (
            <div></div>
        );        
    }



    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);

        setRow( {...row, ['godzina1']:'', ['tresc1']:'',  ['godzina2']: '', ['tresc2']:'' ,  ['godzina3']: '', ['tresc3']:'' }  );
        setB64( {...b64, ['crypt']:'', ['nazwa']:'', ['b64']:''    } );

        getData();
    }




    var dayContent = <div className="gocenter">
        Wybierz dzień z kalendarza
    </div>


    var daySelected = "";

    for(var k=0; k < daysSelected.length; k++)
    {
        daySelected +=  " " + daysSelected[k].date;
    }

    if(daySelected != '____-__-__')
    {

        var xList = <div>
            
            <div className="mobile_form_tab form_tab">
                
                <div className="form_tab_title">Śniadanie</div>
                <div className="form_control form_control_50">
                    <InputTime   userData={props.userData} value={row.godzina1} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina1" placeholder={"Godzina: "} className=' w100 ' req='0'   />
                    <InputTime   userData={props.userData} value={row.godzina1} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina1" placeholder={"Godzina: "} className=' w100 ' req='0'   />
                
                </div>
                <div className="form_control">
                    <InputTextArea   userData={props.userData} value={row.tresc1} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="tresc1" placeholder={"Treść: "} className='  ' req='0'   />                      
                </div>
            </div>

            <div className="mobile_form_tab form_tab">
                <div className="form_tab_title">Obiad</div>
                <div className="form_control form_control_50">
                    <InputTime   userData={props.userData} value={row.godzina2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina2" placeholder={"Godzina: "} className=' w100' req='0'   />                            
                    <InputTime   userData={props.userData} value={row.godzina2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina2" placeholder={"Godzina: "} className=' w100' req='0'   />                            
                </div>
                <div className="form_control">
                    <InputTextArea   userData={props.userData} value={row.tresc2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="tresc2" placeholder={"Treść: "} className='  ' req='0'   />                           
                </div>
            </div>

            <div className="mobile_form_tab form_tab">
                <div className="form_tab_title">Podwieczorek</div>
                <div className="form_control form_control_50">
                    <InputTime   userData={props.userData} value={row.godzina3} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina3" placeholder={"Godzina: "} className=' w100' req='0'   />                           
                    <InputTime   userData={props.userData} value={row.godzina3} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina3" placeholder={"Godzina: "} className=' w100' req='0'   />                           
                </div>
                <div className="form_control">
                    <InputTextArea   userData={props.userData} value={row.tresc3} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="tresc3" placeholder={"Treść: "} className='  ' req='0'   />                          
                </div>
            </div>

            <div className="xtabs_content filter_btn ">
                <span className="btn" onClick={saveData}>zapisz i publikuj</span>
             </div>

        </div>


        var xImage = <div>
                    <div class="form_tab_title">Zdjęcie / Plik .pdf</div>
                    <br/>
                    <span className="link_color" onClick={delImages}>usuń</span>
                    {
                        ( b64.type == "jpg" || b64.type == "jpeg" || b64.type == "png" )   && 
                        <img className="p100" src={ "data:image/jpeg;base64, " + b64.b64} />  
                    }
                    {
                        ( b64.type == "pdf"  )   && 
                        <iframe src={"data:application/pdf;base64," + b64.b64}  height="200px" width="100%"></iframe>
                    }
                                                                   
        </div>


        if(b64.b64.length < 10)  xImage = <div>
                                        <div class="form_tab_title">  Zdjęcie / Plik .pdf</div>
                                        <br/> 
                                        <sup className="link_color_btn">
                                                <InputUploader   userData={props.userData}  typ="none"  typId={-1} remove="0" crypt={row.crypt} completeUpload={completeUpload} title="dodaj plik" max_files="10" ext="image/png, image/jpeg, .pdf" />                               
                                        </sup> 
                    </div>


        var xCont = null;
        var css1 = "";
        var css2 = "";

        if(view == 'list') {xCont = xList; css1 = "xItemSelected"; }
        if(view != 'list') {xCont = xImage; css2 = "xItemSelected"; }

        dayContent = <div>



                <div className="xTabs">
                    <div className={"xItem " +  css1} onClick={changeView} v="list" >Tekst</div>
                    <div className={"xItem " +  css2}  onClick={changeView} v="image">Zdjęcie lub Pdf</div>           
                </div>
                
                <div className='eForm bg_cente'>
                       {xCont}
                </div>
             
        </div>
    }


   


    return (
        <div>
                <div className="view_content">


                    <div className="bg_center">


                        <div className="block50">

                                <Calendar tab={daysSelected} clickOnDay={clickOnDay} />

                        </div>
                        

                        <div className="block50">
                            
                            <div className="calColor">Jadłospis na {daySelected}</div>

                             <div className="eat_item">
                           
                                 <div className="eat_content">
                                         {dayContent}
                                 </div>
                             </div>

                     </div>

                        

                    </div>
                </div>
        </div>
    )
}


export default Eat;